import React, { useState, useEffect, useRef } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import api from '@helpers/api';
import { useCommunity } from "contexts/community";
import Parser from '@helpers/parser';
import { LoopRounded } from '@mui/icons-material';
import Popper from '@components/Popper';
import Table from '@components/Table';
import StatusChip from '@fragments/StatusChip';
import { Text } from "@fragments";

export function SubscriptionTable({ userId }) {
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const popperRef = useRef();

    const { community, loading: communityLoading } = useCommunity();

    useEffect(() => {
        if (userId && !communityLoading) {
            fetchSubscriptions();
        }
    }, [userId, communityLoading]);

    console.log(subscriptions);

    const fetchSubscriptions = async () => {
        try {
            if (loading) return;
            setLoading(true);
            let { data } = await api.get(`subscription?member=${userId}`);
            console.log(data);
            if (data.length > 0) {
                data = data.map(subscription => {
                    subscription.community = community.get(subscription.community);
                    return subscription;
                });
            }
            console.log(data);
            setSubscriptions([...(data || [])]);
        } catch (error) {
            console.error('Error fetching subscriptions:', error);
            setSubscriptions([]);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };



    const handleOpenPopper = (event, subscription) => {
        const options = [
            {
                id: 'cancel',
                label: 'Cancelar assinatura',
                icon: <DeleteRoundedIcon fontSize="small" />,
                variant: 'danger',
                onClick: () => {
                    // Abrir o Confirm ao invés de executar diretamente
                    window.openConfirm({
                        title: 'Cancelar assinatura',
                        subtitle: 'Tem certeza que deseja cancelar esta assinatura?',
                        variant: 'danger',
                        confirmText: 'Cancelar a assinatura',
                        cancelText: 'Manter ativa',
                        buttons: [
                            {
                                text: "Cancelar a assinatura",
                                onClick: async () => {
                                    try {
                                        const { data } = await api.delete('subscription?id=' + subscription.id);
                                        fetchSubscriptions()
                                    } catch (error) {
                                        console.error('Erro ao cancelar assinatura:', error);

                                    }
                                },
                            },
                            {
                                text: "Manter ativa",
                                variant: "text",
                            },
                        ]
                    });
                }
            }
        ];

        popperRef.current.open(options, 'bottom', event.currentTarget);
    };

    const rowsConfig = [
        {
            title: 'Comunidade',
            className: 'pl-1',
            customRender: (data) => (
                <>
                    <img
                        src={data.community?.banner || ''}
                        className="community-row-banner"
                    />
                    <span className="community-name">
                        {data.community?.name || 'N/A'}
                    </span>
                    {(() => {
                        const StatusComponent = {
                            'active': StatusChip.Success,
                            'canceled': StatusChip.Error,
                            'expired': StatusChip.Alert,
                            'unknown': StatusChip.Default,
                        }[data.status || 'default'];

                        return <StatusComponent text={Parser.payment.subscriptionStatus(data.status)} />;
                    })()}
                </>
            )
        },
        {
            title: 'Recorrência',
            align: 'center',
            customRender: (data) => Parser.interval.adjective(data.plan.interval)
        },
        {
            title: 'Plano',
            render: (data) => (
                <span className="plan-info">
                    {data.plan?.label},
                    R${Parser.price.brl(data.plan?.price) || '0,00'} / {Parser.interval.noun(data.plan.interval)}
                </span>
            )
        },
        {
            title: 'Próxima fatura',
            render: (data) => formatDate(data.renewed_until)
        },
        {
            title: '',
            className: 'actions',
            customRender: (data) => (
                <button
                    className={`action-button ${data.status?.toLowerCase() === 'canceled' ? 'disabled' : ''}`}
                    onClick={(event) => handleOpenPopper(event, data)}
                    disabled={data.status?.toLowerCase() === 'canceled'}
                >
                    <MoreVertIcon />
                </button>
            )
        }
    ];

    return (
        <>
            <Text.h3 value="Assinaturas" className='mb-2 mt-5' left={<LoopRounded />} />
            <Table
                data={subscriptions}
                loading={loading}
                loadingRows={4}
                emptyMessage="Nenhuma assinatura encontrada"
                layout="subscription-layout"
                rowsConfig={rowsConfig}
            />
            <Popper controlRef={popperRef} />
        </>
    );
}
